const PATTERN_LAST_PART_LINK = /\/([a-zA-Z\-.0-9]*)$/

export const getFileNameFromLink = (link) => {
    return link.match(PATTERN_LAST_PART_LINK).pop()
}